import { ServiceTypeEnum } from '@sr-sdks/api-sdk-axios';
import { AppCard } from '../../../components/AppCard';
import { MSR3StatementTable } from '../../../components/MSR3StatementTable';
import { PageHeader } from '../../../components/PageHeader';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';
import { MSR3BaseLayout } from '../../../layout/MSR3BaseLayout';

interface ScopedStatementsPageProps {
  /** The export page this list's CSV download is filed under. */
  csvFileLabel: string;
  /** Distinct URL query param for this page's pagination state. */
  paginationKey: string;
  serviceTypes: ServiceTypeEnum[];
  title: string;
}

/**
 * Shared scaffold for the MSR3 Payments statement pages (Disbursements,
 * Residuals, ...). Renders a workspace's paid invoices scoped to the given
 * service types; callers vary only the title, the service-type filter, and the
 * pagination key.
 */
export const ScopedStatementsPage = ({
  csvFileLabel,
  paginationKey,
  serviceTypes,
  title,
}: ScopedStatementsPageProps) => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();

  return (
    <MSR3BaseLayout
      pageHeader={<PageHeader title={title} />}
      sidebarVariant="workspace"
    >
      <AppCard className="mt-10 items-start gap-5">
        <SingleQueryResults query={activeWorkspaceQuery}>
          {(workspace) => (
            <MSR3StatementTable
              csv={{ fileLabel: csvFileLabel, label: title }}
              paginationKey={paginationKey}
              serviceTypes={serviceTypes}
              showRichEmptyState
              workspaceId={workspace._id}
            />
          )}
        </SingleQueryResults>
      </AppCard>
    </MSR3BaseLayout>
  );
};
